import './App.css';
import McLarenCanvas from './McLarenCanvas';

function App() {
  return (
    <div className="flex justify-center items-center h-screen w-screen">
      <McLarenCanvas />
    </div>
  );
}

export default App;
